/* unplugin-vue-components disabled */import { render } from "./taoci.vue?vue&type=template&id=fef83574&scoped=true"
import script from "./taoci.vue?vue&type=script&lang=js"
export * from "./taoci.vue?vue&type=script&lang=js"

import "./taoci.vue?vue&type=style&index=0&id=fef83574&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef83574"]])

export default __exports__